// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd3ca11d","667":"8325f4f6","977":"57bec574"}[chunkId] + ".chunk.js";
};